import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from './client'
import { queryKeys } from '../lib/query'

interface FirefliesStatus {
  connected: boolean
  connectedAt?: string
  webhookId?: string
  transcriptCount: number
  encryptionConfigured: boolean
}

interface FirefliesTranscript {
  id: string
  title: string
  date: string
  duration: number
  transcript_url: string
}

export function useFirefliesStatus() {
  return useQuery({
    queryKey: queryKeys.integrations.fireflies,
    queryFn: () => api.get<FirefliesStatus>('/integrations/fireflies/status'),
  })
}

export function useConnectFireflies() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (apiKey: string) =>
      api.post<{ connected: boolean; connectedAt: string }>('/integrations/fireflies/connect', { apiKey }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.integrations.fireflies })
    },
  })
}

export function useDisconnectFireflies() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => api.delete('/integrations/fireflies/disconnect'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.integrations.fireflies })
    },
  })
}

export function useFirefliesTranscripts() {
  return useQuery({
    queryKey: [...queryKeys.integrations.fireflies, 'transcripts'],
    queryFn: () => api.get<FirefliesTranscript[]>('/integrations/fireflies/transcripts'),
    enabled: false, // Only fetch on demand
  })
}
